export default {
  init() {
    // JavaScript to be fired on the home page

    // $('#showHeader').on('click',function(){
    //   $('#nav-menu').toggle();
    // });
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js